<template>
  <v-tooltip bottom :disabled="!hasBonus || hideBonus">
    <v-icon
      slot="activator"
      :color="color"
      class="shift-details-icon"
      > {{ bonusIcon }} </v-icon>
    <span>${{ bonusAmount }}</span>
  </v-tooltip>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'BonusView',
  props: [
    'shift',
    'type',
    'role',
  ],
  components: {
  },
  computed: {
    hasBonus: function () {
      const has = eval(`this.shift.has${ this.type.charAt(0).toUpperCase() + this.type.slice(1) }Bonus`)
      return has
    },
    hideBonus: function() {
      if (this.shift.id == '1864') {
        console.log('hi');
        console.log("type ", this.type, "cover ", this.shift.hasCoverBonus, "role ", this.role);
      }
      return (
        this.type == 'callIn' &&
        this.shift.hasCoverBonus &&
        this.role == 'client'
      );
    },
    color: function () {
      if (this.hideBonus) {
        return 'grey lighten-2'
      }
      if (this.hasBonus) {
        return 'grey darken-2'
      } else {
        return 'grey lighten-2'
      }
    },
    bonusIcon: function () {
      if (this.type == 'travel') {
        return "directions_car"
      } else if (this.type == 'callIn') {
        return "phone"
      } else {
        return "local_atm"
      }
    },
    bonusAmount: function () {
      const amount = eval(`this.shift.${ this.type }BonusAmountDecimal`)
      const parsedAmount = parseInt(amount.replace(/,/g, '')) // remove commas!

      const twoThirds = (2/3)
      const twoThirdsAmount = parsedAmount * twoThirds

      if (this.role == 'employee') {
        return Math.trunc(twoThirdsAmount) // round down to whole dollar
      } else {
        return parsedAmount
      }

    },
  },
  created () {
  },
  watch: {
  },
  data: function () {
    return {
      example: 'test'
    }
  },
  methods: {
    getBonusAmount () {
    },
  },
}
</script>

<style scoped>
</style>
